<template>
    <section
        v-if="slice.primary"
        :id="slice.primary.anchorName || undefined"
        ref="section"
        class="slice slice-profiles slice-profiles--grid"
        aria-label="profiles"
        data-testid="slice-profiles-grid"
    >
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" data-testid="slice-profiles-grid-title" />
            <PrismicRichText
                v-if="slice.primary.subtitle"
                :field="slice.primary.subtitle"
                class="slice-subtitle"
                data-testid="slice-profiles-grid-subtitle"
            />
            <PrismicRichText
                v-if="slice.primary.description"
                :field="slice.primary.description"
                class="slice-description"
                data-testid="slice-profiles-grid-description"
            />
            <div class="slice-body">
                <div class="slice-profiles--grid__thumbnail-grid" data-testid="slice-profiles-grid-thumbnails">
                    <ProfilesThumbnail v-for="(profile, i) in slice.primary.profiles" :key="i" :profile="profile" :index="i" />
                </div>
            </div>
            <div v-if="isFilled.link(slice.primary.cta)" class="slice-footer">
                <VJoyButton
                    :href="slice.primary.cta.url ? $withLocalePrefix(slice.primary.cta.url) : undefined"
                    data-component-source="consultant-profiles"
                    data-testid="slice-profiles-grid-cta"
                >
                    {{ slice.primary.cta.text }}
                </VJoyButton>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {isFilled} from '@prismicio/helpers';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {ProfilesSlice} from '@prismicio-types';

    import {useComponentTracking} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import ProfilesThumbnail from '../components/ProfilesThumbnail.vue';

    type ProfilesGridVariation = Extract<ProfilesSlice, {variation: 'profilesGrid'}>;

    defineProps(getSliceComponentProps<ProfilesGridVariation>());

    const section = useTemplateRef('section');

    useComponentTracking(section);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-profiles--grid {
        &__thumbnail-grid {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 0 auto;

            @include mq.screen_md(min) {
                padding: 0 var(--joy-core-spacing-8);
            }

            > div {
                width: 100%;
                @include mq.screen_xs(min) {
                    width: 50%;
                }
                @include mq.screen_sm(min) {
                    width: 33.33%;
                }
                @include mq.screen_md(min) {
                    width: 25%;
                }

                a {
                    text-decoration: none;
                }
            }
        }
    }
</style>
